// This is a part of the Cadcorp SIS source code. 
// Copyright (c) Cadcorp Limited 1991-2026 
import { ISearchFactory, ISearchConfig, ISearch } from '../../../../CommonScripts/Abstractions';

export class SearchFactory implements ISearchFactory {
    createSearch(config: ISearchConfig): ISearch {
         return new config.extendedConfiguration.searchConstructor(config);
    }
}

